import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {AddServiceSequenceModel} from "../../models/add-service-sequence.model";
import {ResourceAllocationEditType} from "../../types/resourceAllocationEdit.type";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";

export class resourceAllocationPanelInfoCtrl implements IController {

  template?: any;
  allocation: any;
  routeId: string;
  route: any;
  resource: any;
  serviceAreas: any;
  isEditSequence: boolean;
  resourceAllocationEditType?: ResourceAllocationEditType;
  allocationServiceAreas: any;
  onToggleBlockRoute: Function;
  onOpenEditView: Function;
  onUpdateAllocation: Function;
  onCreateRecurringServiceSequence: Function;
  onChangeIsEditSequence: Function;
  onOpenCreateView: Function;


  public todayDate: string;
  public routeActionsMap: any;
  public accountsMap: Object;
  public depotsMap: Object;
  public allocationCopy?: any;
  public enableAddRecurringServiceBySkillMap: any;
  public resourceAllocationEditTypes: typeof ResourceAllocationEditType = ResourceAllocationEditType;


  private accountsRef: any;
  private depotsRef: any;
  private recurringServicesRef: any;
  private extraTimeInMinutes: number;
  private recurringType: any;
  private priorities: any;
  private isSameDate: boolean;

  /* @ngInject */
  constructor(private commonsConstants, private resourcesConstants, private moment, private $state,
              private $accounts, private $depots, private $recurringServices, private $log, private leanPlanningService: LeanPlanningService,
              private deliveriesDialogService: DeliveriesDialogService, private $window: IWindowService,
              private siteContextService: SiteContextService, private leanPlanningConstants, private servicesService: ServicesService) {
    this.accountsRef = $accounts();
    this.depotsRef = $depots();
    this.recurringServicesRef = this.$recurringServices();
  }

  $onInit() {
    this.todayDate = this.moment().startOf('day').valueOf();
    this.extraTimeInMinutes = _.get(this.allocation, 'extraTimeInMillis') / 60000 || undefined;
    this.isSameDate = this.moment(this.allocation.schedule.startTime).isSame(this.moment(this.allocation.schedule.endTime), 'day');

    // this.rruleTypes = this.commonsConstants.recurringTypes;
    // const rrule = require('rrule');
    // const ruleOptions = rrule.RRule.fromString(_.get(this.allocation, 'schedule.rrule') || '').origOptions;
    // this.recurringType = this.template?.schedule?.freq ? _.find(this.commonsConstants.recurringTypes, (t) => {
    //   return t === this.template.schedule.freq;
    // }) : undefined

    const prioritiesRef = angular.copy(this.resourcesConstants.serviceAreasPriorities);
    this.priorities = _.mapKeys(prioritiesRef, (priority) => {
      return priority.value;
    });

    if (!!this.route) {
      this.routeActionsMap = this.leanPlanningService.getRoutesActionsMap([this.route]);
    }

    //
    this._getAllocationSequenceLocations(this.allocation);
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.template) {
      this.recurringType = this.template?.schedule?.freq ? _.find(this.commonsConstants.recurringTypes, (t) => {
        return t === this.template.schedule.freq;
      }) : undefined
    }

    if (changes.allocation && !changes.allocation.isFirstChange()) {
      this.allocationCopy = undefined;
      this._getAllocationSequenceLocations(this.allocation);
    }

    if (changes.isEditSequence && !changes.isEditSequence.isFirstChange()) {
      this.allocationCopy = this.isEditSequence ? angular.copy(this.allocation) : undefined;
    }

    if (changes.resource) {
      this.enableAddRecurringServiceBySkillMap = {};
      this.resource?.requiredSkills?.forEach((s) => {
        this.enableAddRecurringServiceBySkillMap[s] = true;
      })
    }

    if (changes.route && !changes.route.isFirstChange()) {
      this.routeActionsMap = {};
      if (!!this.route) {
        this.routeActionsMap = this.leanPlanningService.getRoutesActionsMap([this.route]);
      }
    }
  }

  getSegmentTime(segment) {
    const segmentStartTime = this.allocation.schedule.startTime + segment.offsetInMillis;
    const segmentEndTime = segmentStartTime + segment.durationInMillis;

    return {notBefore: segmentStartTime, notAfter: segmentEndTime}
  }

  getServiceAreaName(areaId) {
    if (areaId && this.serviceAreas.length) {
      const area = _.find(this.serviceAreas, (a) => {
        return a.areaId === areaId;
      });
      return area?.areaName || '--';
    }
  }

  onOpenRoute(routeId) {
    const url = this.$state.href('planning-route', {id: routeId});
    this.$window.open(url, '_blank');
  }

  // onChangeIsEditingSequence(isEditingSequence: boolean) {
  //   this.allocationCopy = isEditingSequence ? angular.copy(this.allocation) : undefined;
  // }

  onSequenceLocationTypeSelect() {
    if (!this.allocationCopy.details) {
      this.allocationCopy.details = this.allocation.details || [];
    }
    this.allocationCopy.recurringServiceDetails = undefined;
  }

  onSequenceRecurringServicesTypeSelect() {
    if (!this.allocationCopy.recurringServiceDetails) {
      this.allocationCopy.recurringServiceDetails = this.allocation.recurringServiceDetails || [];
    }
    this.allocationCopy.details = undefined;
  }

  onAddLocationSequence() {
    if (!this.allocationCopy.details) {
      this.allocationCopy.details = [];
    }
    this.allocationCopy.details.push({
      holderId: undefined,
      sequence: this.allocationCopy.details.length + 1,
      type: "ACCOUNT"
    })
  }

  onAddRecurringServiceSequence($event, serviceType) {
    const notBefore = this.allocation.schedule.startTime;
    const notAfter = this.allocation.schedule.endTime;
    const byWeekDay = this.template?.schedule.byWeekDay;
    const endRecurring = (!this.recurringType || (this.resourceAllocationEditType === ResourceAllocationEditType.EVENT)) ? notAfter : undefined;
    this.deliveriesDialogService.createRecurringService($event, serviceType, undefined, notBefore, notAfter, this.recurringType, byWeekDay, endRecurring, this.template?.schedule?.interval, this.resource.zoneId)
      .then((recurringServicePayload) => {
        this.allocationCopy.recurringServiceDetails.push({
          recurringServiceTemplate: recurringServicePayload,
          sequence: this.allocationCopy.recurringServiceDetails.length + 1
        })
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onAddEmptyRecurringServiceSequence($event) {
    this.allocationCopy.recurringServiceDetails.push({
      recurringServiceTemplateId: undefined,
      sequence: this.allocationCopy.recurringServiceDetails.length + 1
    })
  }

  onLocationTypeChange(sequenceDetails, type) {
    sequenceDetails.type = type;
    sequenceDetails.holderId = undefined;
  }

  onAccountSelect(account, sequenceDetails, $index) {
    sequenceDetails.holderId = account?.id;
  }

  onDepotSelect(depot, sequenceDetails, $index) {
    sequenceDetails.holderId = depot?.id;
  }

  onRecurringServiceChange(recurringService, sequenceDetails, $index) {
    sequenceDetails.recurringServiceTemplateId = recurringService?.id;
  }

  onRemoveLocation($index) {
    this.allocationCopy.details.splice($index, 1);
  }

  onRemoveRecurringService($index) {
    this.allocationCopy.recurringServiceDetails.splice($index, 1);
  }

  onUpdateLocationSequence(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.allocationCopy.details.forEach((d, index) => {
          d.sequence = (index + 1);
        })
        this.onUpdateAllocation({allocation: this.allocationCopy})
        this.allocationCopy = undefined;
      }
    }
  }

  onUpdateRecurringServicesSequence(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this._updateRecurringServicesSequence()
      }
    }
  }

  onEditRecurringService($index, id, $event) {
    this.recurringServicesRef.$getAll({ids: [id]})
      .then((ids) => {
        return this.recurringServicesRef.$asyncValues(ids)
      })
      .then((services) => {
        return this.deliveriesDialogService.editRecurringService($event, services[0])
      })
      .then((editedService) => {
        this._updateRecurringService(editedService);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })

    // this.recurringServicesRef.$asyncValues([id])
    //   .then((services) => {
    //     return this.deliveriesDialogService.editRecurringService($event, services[0])
    //   })
    //   .then((editedService) => {
    //     this._updateRecurringService(editedService);
    //   })
    //   .catch(() => {
    //     this.$log.info('Dialog Closed');
    //   })
  }

  private _updateRecurringService(recurringService) {
    this.servicesService.updateRecurringService(recurringService.id, recurringService)
      .then((updatedRecurringService) => {
        const payload: AddServiceSequenceModel = {
          recurringServiceTemplateSequences: _.map(this.allocation.recurringServiceDetails, (d) => {
            return {
              recurringServiceTemplateId: d.recurringServiceTemplateId,
              recurringServiceTemplate: d.recurringServiceTemplate,
              sequence: d.sequence
            }
          })
        }
        this.onCreateRecurringServiceSequence({payload: payload, allocation: this.allocation});
      })
  }

  private _updateRecurringServicesSequence() {
    this.allocationCopy.recurringServiceDetails.forEach((d, index) => {
      d.sequence = (index + 1);
    })

    const payload: AddServiceSequenceModel = {
      recurringServiceTemplateSequences: _.map(this.allocationCopy.recurringServiceDetails, (d) => {
        return {
          recurringServiceTemplateId: d.recurringServiceTemplateId,
          recurringServiceTemplate: d.recurringServiceTemplate,
          sequence: d.sequence
        }
      })
    }

    this.onCreateRecurringServiceSequence({payload: payload, allocation: this.allocation});
    // this.allocationCopy = undefined;
  }

  private _getAllocationSequenceLocations(allocation) {
    this.depotsMap = {};
    this.accountsMap = {};
    const depotIds = [];
    const accountIds = [];

    if (_.get(allocation, 'details.length')) {

      this.allocation.details.forEach((d) => {
        if (d.type === "DEPOT") {
          depotIds.push(d.holderId);
        }
        if (d.type === "ACCOUNT") {
          accountIds.push(d.holderId);
        }
      })
    }

    if (_.get(allocation, 'locationSettings.departurePointType') === 'DEPOT' && _.get(allocation, 'locationSettings.departureId')) {
      depotIds.push(allocation.locationSettings.departureId);
    }

    if (_.get(allocation, 'locationSettings.destinationPointType') === 'DEPOT' && _.get(allocation, 'locationSettings.destinationId')) {
      depotIds.push(allocation.locationSettings.destinationId);
    }

    if (_.get(this.resource, 'locationSettings.departurePointType') === 'DEPOT' && _.get(this.resource, 'locationSettings.departureId')) {
      depotIds.push(this.resource.locationSettings.departureId);
    }

    if (_.get(this.resource, 'locationSettings.destinationPointType') === 'DEPOT' && _.get(this.resource, 'locationSettings.destinationId')) {
      depotIds.push(this.resource.locationSettings.destinationId);
    }

    if (depotIds.length) {
      this._setAllocationDepots(_.uniq(depotIds));
    }
    if (accountIds.length) {
      this._setAllocationAccounts(accountIds);
    }
  }

  private _setAllocationAccounts(accountIds) {
    this.$accounts().$asyncValues(accountIds)
      .then((accounts: AccountModel[]) => {
        this.accountsMap = _.keyBy(accounts, 'id');
      })
      .catch((err) => {
        this.$log.error(err);
      })
  }


  private _setAllocationDepots(depotIds) {
    this.depotsRef.$asyncValues(depotIds)
      .then((depots) => {
        this.depotsMap = _.keyBy(depots, 'id');
      })
      .catch((err) => {
        this.$log.error(err);
      })
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationPanelInfo', {
    bindings: {
      template: '<?',
      allocation: '<',
      routeId: '<?',
      route: '<?',
      resource: '<',
      serviceAreas: '<',
      isEditSequence: '<?',
      resourceAllocationEditType: '<?',
      allocationServiceAreas: '<',
      onToggleBlockRoute: '&',
      onOpenEditView: '&',
      onUpdateAllocation: '&',
      onCreateRecurringServiceSequence: '&',
      onChangeIsEditSequence: '&',
      onOpenCreateView: '&'
    },
    template: require('./resource-allocation-panel-info.html').default,
    controller: resourceAllocationPanelInfoCtrl
  });
